module.exports = __webpack_public_path__ + "static/media/2-7.28208ee6.mp3";